<style lang="stylus">
    .outputPDF-mask
        modal-mask()
        .outputPDF-modal
            width 842px
            max-width 100%
            height 60vh
            .dialog-slot
                height calc(100% - 40px)
            .outputPDF-container
                display flex
                height calc(100% - 40px)
                .outputPDF-showbox
                    width 41%

                    display flex
                    justify-content center
                    align-items center
                    background var(--bg-color-output-modal-show-box)
                    border 1px solid var(--border-color-box-6)
                    border-radius 6px
                    overflow auto
                    img
                        width 264px
                        box-shadow 0px 4px 20px rgba(0, 0, 0, 0.1)
                .outputPDF-optionbox
                    width 59%
                    height 100%
                    overflow auto
                    margin-left 16px
                    .outputPDF-box
                        display flex
                        flex-wrap wrap
                        margin-bottom 8px
                        .outputPDF-optionbox-title
                            font-size 12px
                            line-height 24px
                            width 70px
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                        .right
                            width calc(100% - 76px)
                            margin-left 6px
                            position relative
                            display flex
                            flex-wrap wrap
                            align-items center
                            .check-box-item
                                height 24px
                                padding 0 16px
                                border 1px solid var(--border-color-gray-10)
                                border-radius 6px
                                margin 0 16px 8px 0
                                display flex
                                align-items center
                                &:last-child
                                    margin-right 0
                                &.checked
                                    position relative
                                    border-color var(--themeColor)
                                    .tick-icon
                                        display block
                                &:hover
                                    border-color var(--themeColor)
                                .tick-icon
                                    display none
                                    position absolute
                                    top 0
                                    right 0
                                    height 18px
                                    width 18px;
                                    color var(--themeColor)
                                .vip-icon
                                    margin-right 8px
                                    width 12px
                                    height 12px
                            .selectInput-label
                                position absolute
                                display flex
                                align-items center
                                height 18px
                                top 3px
                                right 16px
                                z-index -1
                    .ivu-select-disabled
                        .ivu-select-selection
                            background-color var(--bg-color-ivu-input-number-input-disabled)
                    .ivu-select-selection
                        width 100%
                        background-color transparent
                    .outputPDF-typebox,.outputPDF-rangebox
                        margin-bottom 12px
                        .outputPDF-selector
                            .ivu-select-item
                                display flex
                                align-items center
                                position relative
                            .vip-icon
                                margin-left 8px
                    .outputPDF-typebox
                        .tag-box
                            display flex
                            align-items center
                            color #FF8E33
                            position absolute
                            right 8px
                            white-space nowrap
                            img
                                margin-right 4px
                            span
                                display inline-block
                                max-width 72px
                                overflow hidden
                                text-overflow ellipsis
                                white-space nowrap
                    .outputPDF-rangebox
                        padding-bottom 12px
                        border-bottom 1px solid var(--border-color-gray-10)
                        .ivu-input
                            margin-top 12px
                            height 24px
            .ivu-select-dropdown
                padding 6px
                box-shadow $box-shaow
                border-radius 8px
            .ivu-select-arrow
                right 2px
            .dialog-btnbox-normal
                margin-top 16px
</style>

<template>
    <div class="outputPDF-mask">
        <Dialog class="outputPDF-modal" :title="$t('title')" :isShow="true" @close="cancel">
            <div class="outputPDF-container">
                <div class="outputPDF-showbox">
                    <img :src="previewImg" alt="" />
                </div>
                <div class="outputPDF-optionbox">
                    <div class="outputPDF-typebox outputPDF-box">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-name')">{{ $t("subTitle-name") }}</p>
                        <Input class="right" v-model="fileName" size="small" :placeholder="fileNameSync" :disabled="EDCONFIG.IS_SDK" />
                    </div>
                    <div class="outputPDF-typebox outputPDF-box">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-type')">{{ $t("subTitle-type") }}</p>
                        <div class="right">
                            <i-select class="outputPDF-selector" v-model="typeRadio" size="small" @on-change="setTypeLabelLeft">
                                <i-option v-for="item in typeList" :value="item.id" :key="item.id" :label="$t(item.name)">
                                    <span>{{ $t(item.name) }}</span>
                                    <VipIcon v-if="!vip && item.showVip" />
                                    <div class="tag-box" v-if="item.id == 1">
                                        <img class="vip-icon" src="@/app/assets/img/dialog/export/tag.svg" alt="" />
                                        <span :title="$t('anti-lost')">{{ $t("anti-lost") }}</span>
                                        <img class="vip-icon" style="margin-left: 8px" src="@/app/assets/img/dialog/export/tag.svg" alt="" />
                                        <span :title="$t('tamper-proof')">{{ $t("tamper-proof") }}</span>
                                    </div>
                                </i-option>
                            </i-select>
                            <div class="selectInput-label" ref="selectTypeInputLabel" v-if="typeRadio == 1">
                                <VipIcon v-show="!vip" />
                                <div class="tag-box">
                                    <img class="vip-icon" src="@/app/assets/img/dialog/export/tag.svg" alt="" />
                                    <span :title="$t('anti-lost')">{{ $t("anti-lost") }}</span>
                                    <img class="vip-icon" style="margin-left: 8px" src="@/app/assets/img/dialog/export/tag.svg" alt="" />
                                    <span :title="$t('tamper-proof')">{{ $t("tamper-proof") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="outputPDF-rangebox outputPDF-box">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-range')">{{ $t("subTitle-range") }}</p>
                        <div class="right">
                            <i-select class="outputPDF-selector" v-model="shapeRadio" size="small" @on-change="setShapeLabelLeft">
                                <!-- <i-option v-for="item in shapeList" :value="item.id" :key="item.id" :disabled="(item.id == 2) && !selectShape"> -->
                                <i-option
                                    v-for="item in shapeList"
                                    :value="item.id"
                                    :key="item.id"
                                    :label="$t(item.name)"
                                    :disabled="(item.id == 3 && !selectShape) || (item.id == 4 && !hasPageShape)"
                                >
                                    <span>{{ $t(item.name) }}</span>
                                    <VipIcon v-if="!vip && item.showVip" />
                                </i-option>
                            </i-select>
                            <div class="selectInput-label" ref="selectShapeInputLabel" v-if="shapeRadio !== 0 && shapeRadio !== 1 && !vip">
                                <VipIcon />
                            </div>
                            <Input v-if="shapeRadio == 2" v-model="selectedPageVal" @on-change="changeImage" :placeholder="$t('pageIllustrate')" />
                        </div>
                    </div>

                    <div class="outputPDF-qualitybox outputPDF-box" v-if="typeRadio == 1">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-quality')">{{ $t("subTitle-quality") }}</p>
                        <div class="right">
                            <div
                                v-for="item in resolutionList"
                                :key="item.id"
                                class="check-box-item"
                                :class="{ checked: item.id == resolutionRatio }"
                                @click="changeResolution(item.id)"
                            >
                                <VipIcon v-if="!vip && item.showVip" />
                                <span>{{ $t(item.name) }}</span>
                                <iconSymbol name="export-tick-top" class="tick-icon" />
                            </div>
                        </div>
                    </div>
                    <div class="outputPDF-watermarkBox outputPDF-box">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-watermark')">{{ $t("subTitle-watermark") }}</p>
                        <div class="right">
                            <div
                                v-for="item in watermarkList"
                                :key="item.id"
                                class="check-box-item"
                                :class="{ checked: item.id == watermarkSetting }"
                                @click="changeWatermarkSetting(item.id)"
                            >
                                <VipIcon v-if="!vip && item.showVip" />
                                <span>{{ $t(item.name) }}</span>
                                <iconSymbol name="export-tick-top" class="tick-icon" />
                            </div>
                        </div>
                    </div>
                    <div class="outputPDF-fileNumBox outputPDF-box">
                        <p class="outputPDF-optionbox-title" :title="$t('subTitle-fileNum')">{{ $t("subTitle-fileNum") }}</p>
                        <div class="right">
                            <div
                                v-for="item in fileNumList"
                                :key="item.id"
                                class="check-box-item"
                                :class="{ checked: item.id == fileNumSetting }"
                                @click="changeFileNumSetting(item.id)"
                            >
                                <VipIcon v-if="!vip && item.showVip" />
                                <span>{{ $t(item.name) }}</span>
                                <iconSymbol name="export-tick-top" class="tick-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div @click="cancel">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="beforeConfirm">
                    <span>{{ $t("export") }}</span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    const PDFDocument = require("@/app/utils/pdfkit.min.js");
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class outputPDF extends Vue {
        @Inject()
        ["fileRename"];
        previewImg: string = "";
        selectShape: boolean = false;
        hasPageShape: boolean = false;
        shapeRadio: number = 0;
        fileName = window["_view"]._doc._fileName;
        shapeList = [
            {
                id: 0,
                name: "currentPage",
            },
            {
                id: 1,
                name: "allPage",
            },
            {
                id: 2,
                name: "selectPage",
                showVip: true,
            },

            {
                id: 3,
                name: "selectShape",
                showVip: true,
            },
            {
                id: 4,
                name: "allShape",
                showVip: true,
            },
        ];
        typeRadio: number = 0;
        typeList = [
            {
                id: 0,
                name: "PDFVector",
            },
            {
                id: 1,
                name: "PDFImg",
                showVip: true,
            },
        ];
        resolutionRatio: number = 1;
        resolutionWidth: number = 0;
        resolutionHeight: number = 0;
        resolutionList = [
            {
                id: 0,
                name: "resolution-normal",
            },
            {
                id: 1,
                name: "resolution-origin",
                showVip: true,
            },
        ];
        watermarkSetting: number = 1;
        watermarkList = [
            {
                id: 0,
                name: "default",
            },
            {
                id: 1,
                name: "nonwatermark",
                showVip: true,
            },
        ];
        fileNumSetting: number = 1;
        fileNumList = [
            {
                id: 0,
                name: "singlePDF",
            },
            {
                id: 1,
                name: "multiplePDF",
                showVip: true,
            },
        ];
        selectedPageVal: string = "";
        changeResolution(id: number) {
            let map = new Map([
                [
                    0,
                    () => {
                        return [96, 96];
                    },
                ],
                [
                    1,
                    () => {
                        return [300, 300];
                    },
                ],
            ]);
            this.resolutionRatio = id;
            let arr = map.get(this.resolutionRatio)();
            this.resolutionWidth = arr[0];
            this.resolutionHeight = arr[1];
        }
        changeWatermarkSetting(id: number) {
            this.watermarkSetting = id;
        }
        changeFileNumSetting(id: number) {
            this.fileNumSetting = id;
        }
        calcTextWidth(text: string) {
            const font = "12px 'Noto Sans SC', 'Noto Sans', 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif";
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;
            const { width } = context.measureText(text);
            return width;
        }
        setTypeLabelLeft() {
            let item = this.typeList.filter((item) => item.id === this.typeRadio) as any;
            let textWidth = this.calcTextWidth(String(this.$t(item[0].name)));
            this.$nextTick(() => {
                this.$refs.selectTypeInputLabel && ((this.$refs.selectTypeInputLabel as HTMLElement).style.left = textWidth + 8 + 8 + "px");
            });
        }
        setShapeLabelLeft() {
            this.changeImage();
            let item = this.shapeList.filter((item) => item.id === this.shapeRadio) as any;
            let textWidth = this.calcTextWidth(String(this.$t(item[0].name)));
            this.$nextTick(() => {
                this.$refs.selectShapeInputLabel && ((this.$refs.selectShapeInputLabel as HTMLElement).style.left = textWidth + 8 + 8 + "px");
            });
        }
        beforeConfirm() {
            this.fileRename(this.fileName).then(() => {
                this.confirm();
            });
        }
        confirm() {
            this.setExporCustomPrefer();
            let needVip =
                this.shapeRadio == 2 ||
                this.shapeRadio == 3 ||
                this.shapeRadio == 4 ||
                this.typeRadio == 1 ||
                (this.typeRadio == 1 && this.resolutionRatio == 1) ||
                this.watermarkSetting == 1 ||
                this.fileNumSetting == 1;
            if (!this.vip && needVip) {
                let format = this.typeRadio ? "imagepdf" : "pdf",
                    area = ["Currentpage", "Allpage", "Selectedpage", "Shape", "Allshape"][this.shapeRadio],
                    watermark = this.watermarkSetting ? "Nomark" : "Default",
                    shape = this.fileNumSetting ? "More" : "One";
                let triggerName = `${format}_${area}_${watermark}_${shape}`;
                if (window.EDCONFIG.IS_SDK) {
                    triggerName += "_exportSth";
                }
                this.$openBuyPage(triggerName);
                return;
            }

            let saveToInclowdz = (data) => {
                let reader = new FileReader();
                reader.onload = function (e) {
                    window.parent.postMessage(
                        {
                            mode: "iframe2parent",
                            target: "file",
                            action: "export",
                            type: "request",
                            session_id: "0000000003",
                            version: "v1",
                            data: {
                                filename: data.name,
                                filesize: data.size,
                                base64_data: (<any>e.target).result,
                            },
                        },
                        "*"
                    );
                };
                reader.readAsDataURL(data.blob);
            };

            let allPageList: Array<number> = [];
            if (this.shapeRadio == 2) {
                let selectedPageVal = this.selectedPageVal.replace("，", ",");
                let range = selectedPageVal.split(",");
                let reg1 = /\d+/g;
                let reg2 = /\d+-\d+/g;
                for (let i = 0; i < range.length; i++) {
                    let str = range[i];
                    if (str.match(reg2)) {
                        let pageList = str.split("-");
                        let str1 = pageList[0];
                        let str2 = pageList[1];
                        let pageNum1 = parseInt(str1);
                        let pageNum2 = parseInt(str2);
                        if (pageNum2 >= pageNum1) {
                            for (let j = pageNum1; j <= pageNum2; j++) {
                                if (allPageList.indexOf(j) == -1) {
                                    allPageList.push(j - 1);
                                }
                            }
                        } else {
                            for (let j = pageNum2; j <= pageNum1; j++) {
                                if (allPageList.indexOf(j) == -1) {
                                    allPageList.push(j - 1);
                                }
                            }
                        }
                    } else if (str.match(reg1)) {
                        let pageNum = parseInt(str);
                        if (allPageList.indexOf(pageNum) == -1) allPageList.push(pageNum - 1);
                    } else {
                    }
                }
            }

            let view = window["_view"];
            if (view) {
                import("@/app/utils/pdfDep.js").then((blobStream) => {
                    if (this.isInclowdz) {
                        view.savePdf(PDFDocument, this.typeRadio == 0, blobStream.default, saveToInclowdz);
                    } else {
                        view.savePdf(
                            PDFDocument,
                            this.typeRadio == 0,
                            blobStream.default,
                            null,
                            this.shapeRadio,
                            this.fileNumSetting,
                            this.watermarkSetting == 0,
                            this.resolutionRatio == 1,
                            allPageList
                        );
                    }
                });
            }
            this.cancel();
        }
        cancel() {
            this.previewImg = "";
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        @Watch("shapeRadio")
        changeImage() {
            let view = window["_view"];
            if (!view) return;
            view.changeExportType(this.shapeRadio, this.typeRadio, 0, 0, (data) => {
                this.previewImg = data;
            });
        }
        get fileNameSync() {
            return this.$store.state.ui.fileNameSync;
        }
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        setExporCustomPrefer() {
            let data = this.customPreferContent || {};
            if (
                data["defaultExportPDFWatermark"] === this.watermarkSetting &&
                data["defaultExportPDFRange"] === this.shapeRadio &&
                data["defaultExportPDFType"] === this.typeRadio
            )
                return;
            Object.assign(data, {
                defaultExportPDFWatermark: this.watermarkSetting,
                defaultExportPDFRange: this.shapeRadio,
                defaultExportPDFType: this.typeRadio,
            });
            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }

        mounted() {
            this.selectShape = !!this.$store.state.shape.isActived;
            this.hasPageShape = this.$store.state.ui.exportImageInfo.pageShapeWidth > 0 && this.$store.state.ui.exportImageInfo.pageShapeHeight > 0;
            this.changeImage();
            this.$nextTick(() => {
                // 获取用户最后一次水印选项 默认无水印
                this.watermarkSetting = this.customPreferContent?.["defaultExportPDFWatermark"] === 0 ? 0 : 1;
                // 获取用户最后一次导出范围选项
                this.shapeRadio = this.customPreferContent?.["defaultExportPDFRange"] || 0;
                // 获取用户最后一次导出选项
                this.typeRadio = this.customPreferContent?.["defaultExportPDFType"] ? 1 : 0;
                this.setTypeLabelLeft();
                this.setShapeLabelLeft();
            });
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "title": "导出为PDF",
    "subTitle-name": "文件名称：",
    "subTitle-range": "导出范围：",
    "subTitle-type": "导出选项：",
    "subTitle-quality": "导出品质：",
    "subTitle-watermark": "水印设置：",
    "subTitle-fileNum": "文件个数：",
    "anti-lost": "防丢失",
    "tamper-proof": "防篡改",
    "default": "默认",
    "nonwatermark": "无水印",
    "pageIllustrate": "例如：1,3,5-10",
    "export": "导出",
    "confirm": "确定",
    "cancel": "取消",
    "currentPage": "当前页面",
    "selectPage": "选中的页面",
    "selectShape": "选中的形状",
    "allPage": "所有页面",
    "allShape": "当前页面所有形状",
    "PDFImg": "PDF图片",
    "PDFVector": "PDF矢量",
    "singlePDF": "一个PDF文件",
    "multiplePDF": "多个单独PDF",
    "resolution-normal": "普通",
    "resolution-origin": "高清"
  },
  "en": {
    "title": "Export to PDF",
    "subTitle-name": "File Name:",
    "subTitle-range": "Export range:",
    "subTitle-type": "Export options:",
    "subTitle-quality": "Export quality:",
    "subTitle-watermark": "Watermark settings:",
    "subTitle-fileNum": "Number of documents:",
    "anti-lost": "Loss-proof",
    "tamper-proof": "Tamper-resistant",
    "default": "Default",
    "nonwatermark": "No watermarks",
    "pageIllustrate": "for example: &quot;1,3,5-10&quot;",
    "export": "Export",
    "confirm": "Ok",
    "cancel": "Cancel",
    "currentPage": "Current page",
    "selectPage": "Selected page",
    "selectShape": "Selected shape",
    "allPage": "All pages",
    "allShape": "All shapes on the current page",
    "PDFImg": "Image-based PDF",
    "PDFVector": "Regular PDF",
    "singlePDF": "Export to 1 PDF",
    "multiplePDF": "Export to separated PDFs",
    "resolution-normal": "Normal",
    "resolution-origin": "HD"
  },
  "fr": {
    "title": "Exporter à PDF",
    "subTitle-name": "Nom de fichier:",
    "subTitle-size": "Taille：",
    "subTitle-range": "Plage d'exportation:",
    "subTitle-type": "Options d'exportation:",
    "subTitle-quality": "Qualité des exportations:",
    "subTitle-watermark": "Paramètres de filigrane:",
    "subTitle-fileNum": "Nombre de documents:",
    "anti-lost": "Anti-perte",
    "tamper-proof": "Anti-falsification",
    "default": "Par défaut",
    "nonwatermark": "Aucun filigrane",
    "pageIllustrate": "par exemple: &quot;1,3,5-10&quot;",
    "export": "Exporter",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "currentPage": "Page actuelle",
    "selectPage": "Pages sélectionnées",
    "selectShape": "Formes sélectionnées",
    "allPage": "Toutes les pages",
    "allShape": "Toutes les formes sur la page en cours",
    "PDFImg": "PDF basé sur l'image",
    "PDFVector": "PDF Régulier",
    "singlePDF": "Exporter vers PDF 1",
    "multiplePDF": "Exporter vers des fichiers PDF séparés",
    "resolution-normal": "Normal",
    "resolution-origin": "Source"
  },
  "de": {
    "title": "Als PDF exportieren",
    "subTitle-name": "Dateiname:",
    "subTitle-size": "Größe：",
    "subTitle-range": "Exportbereich:",
    "subTitle-type": "Exportoptionen:",
    "subTitle-quality": "Exportqualität:",
    "subTitle-watermark": "Wasserzeicheneinstellungen:",
    "subTitle-fileNum": "Anzahl an Dokumenten:",
    "anti-lost": "Verlustfrei",
    "tamper-proof": "Manipulationssicher",
    "default": "Standard",
    "nonwatermark": "Kein Wasserzeichen",
    "pageIllustrate": "z. B.: „1,3,5–10“",
    "export": "Exportieren",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "currentPage": "Aktuelle Seite",
    "selectPage": "Ausgewählte Seiten",
    "selectShape": "Ausgewählte Formen",
    "allPage": "Alle Seiten",
    "allShape": "Alle Formen auf der aktuellen Seite",
    "PDFImg": "Bildbasiertes PDF",
    "PDFVector": "Standard PDF",
    "singlePDF": "In 1 PDF exportieren",
    "multiplePDF": "In einzelne PDFs exportieren",
    "resolution-normal": "Normal",
    "resolution-origin": "Quelle"
  },
  "jp": {
    "title": "PDFにエクスポート",
    "subTitle-name": "ファイル名：",
    "subTitle-size": "サイズ：",
    "subTitle-range": "範囲をエクスポート:",
    "subTitle-type": "エクスポートオプション:",
    "subTitle-quality": "エクスポートの品質：",
    "subTitle-watermark": "透かし設定: ",
    "subTitle-fileNum": "ドキュメントの数:",
    "anti-lost": "紛失防止",
    "tamper-proof": "改ざん防止",
    "default": "デフォルト",
    "nonwatermark": "透かしなし",
    "pageIllustrate": "例えば: &quot;1、3、5-10&quot;",
    "export": "エクスポート",
    "confirm": "OK",
    "cancel": "キャンセル",
    "currentPage": "現在のページ",
    "selectPage": "選択したページ",
    "selectShape": "選択した形状",
    "allPage": "すべてのページ",
    "allShape": "現在のページのすべての図形",
    "PDFImg": "画像ベースのPDF",
    "PDFVector": "標準 PDF",
    "singlePDF": "1つの PDFにエクスポート",
    "multiplePDF": "複数のPDFにエクスポート",
    "resolution-normal": "標準",
    "resolution-origin": "源"
  },
  "es": {
    "title": "Exportar a PDF",
    "subTitle-name": "Nombre de Archivo:",
    "subTitle-size": "Tamaño：",
    "subTitle-range": "Rango de exportación:",
    "subTitle-type": "Opciones de exportación:",
    "subTitle-quality": "Calidad de exportación:",
    "subTitle-watermark": "Configuración de marca de agua:",
    "subTitle-fileNum": "Número de documentos:",
    "anti-lost": "A prueba de pérdidas",
    "tamper-proof": "Resistente a interferencias",
    "default": "Estándar",
    "nonwatermark": "Sin marca de agua",
    "pageIllustrate": "por ejemplo: &quot;1,3,5-10&quot;",
    "export": "Exportar",
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "currentPage": "Página Actual",
    "selectPage": "Páginas seleccionadas",
    "selectShape": "Formas elegidas",
    "allPage": "Todas las páginas",
    "allShape": "Todas las formas de la página actual",
    "PDFImg": "PDF basado en imágenes",
    "PDFVector": "Regular PDF",
    "singlePDF": "Exportar a 1 PDF",
    "multiplePDF": "Exportación a PDFs separados",
    "resolution-normal": "Normal",
    "resolution-origin": "Origen"
  },
  "pt": {
    "title": "Exportar para PDF",
    "subTitle-name": "Nome do Arquivo:",
    "subTitle-size": "Tamanho：",
    "subTitle-range": "Intervalo de exportação:",
    "subTitle-type": "Opções de exportação:",
    "subTitle-quality": "Qualidade de exportação:",
    "subTitle-watermark": "Configurações de marca d'água:",
    "subTitle-fileNum": "Número de documentos:",
    "anti-lost": "À prova de perdas",
    "tamper-proof": "À prova de adulteração",
    "default": "Padrão",
    "nonwatermark": "Sem marcas d'água",
    "pageIllustrate": "por exemplo: &quot;1,3,5-10&quot;",
    "export": "Exportar",
    "confirm": "OK",
    "cancel": "Cancelar",
    "currentPage": "Pagina Atual",
    "selectPage": "Páginas Selecionadas",
    "selectShape": "Formas selecionadas",
    "allPage": "Todas as Páginas",
    "allShape": "Todas as formas na página atual",
    "PDFImg": "PDF baseado em Imagem",
    "PDFVector": "PDF Normal",
    "singlePDF": "Exportar para 1 PDF",
    "multiplePDF": "Exportar para PDFs separados",
    "resolution-normal": "Normal",
    "resolution-origin": "Origem"
  },
  "it": {
    "title": "Esporta in PDF",
    "subTitle-name": "Nome File:",
    "subTitle-size": "Dimensione：",
    "subTitle-range": "Range dell'esportazione:",
    "subTitle-type": "Opzioni dell'esportazione:",
    "subTitle-quality": "Qualità dell'esportazione:",
    "subTitle-watermark": "Impostazioni filigrana:",
    "subTitle-fileNum": "Numero di documenti:",
    "anti-lost": "A prova di perdite",
    "tamper-proof": "Resistente alle manomissioni",
    "default": "Predefinito",
    "nonwatermark": "Nessuna filigrana",
    "pageIllustrate": "per esempio: &quot;1, 3, 5-10&quot;",
    "export": "Esporta",
    "confirm": "OK",
    "cancel": "Annulla",
    "currentPage": "Pagina Corrente",
    "selectPage": "Pagine Selezionate",
    "selectShape": "Forme Selezionate",
    "allPage": "Tutte le Pagine",
    "allShape": "Tutte le forme nella pagina corrente",
    "PDFImg": "PDF-Immagine",
    "PDFVector": "PDF Regolare",
    "singlePDF": "Esporta in 1 PDF",
    "multiplePDF": "Esporta in PDF separati",
    "resolution-normal": "Normale",
    "resolution-origin": "Origine"
  },
  "tw": {
    "title": "匯出為PDF",
    "subTitle-name": "檔案名稱：",
    "subTitle-size": "尺寸：",
    "subTitle-range": "匯出範圍：",
    "subTitle-type": "匯出選：",
    "subTitle-quality": "匯出品質：",
    "subTitle-watermark": "浮水印設定：",
    "subTitle-fileNum": "文件數量：",
    "anti-lost": "防失真",
    "tamper-proof": "防篡改",
    "default": "默認",
    "nonwatermark": "無水印",
    "pageIllustrate": "例如： &quot;1,3,5-10&quot;",
    "export": "匯出",
    "confirm": "確定",
    "cancel": "取消",
    "currentPage": "當前頁面",
    "selectPage": "選擇頁面",
    "selectShape": "已選形狀",
    "allPage": "所有頁面",
    "allShape": "目前頁面上的所有形狀",
    "PDFImg": "PDF圖片",
    "PDFVector": "PDF矢量",
    "singlePDF": "匯出為一個PDF檔案",
    "multiplePDF": "匯出為多個單獨的PDF檔案",
    "resolution-normal": "標準",
    "resolution-origin": "高清"
  },
  "kr": {
    "title": "PDF로 내보내기",
    "subTitle-name": "파일 이름:",
    "subTitle-size": "사이즈：",
    "subTitle-range": "내보내기 범위:",
    "subTitle-type": "내보내기 옵션:",
    "subTitle-quality": "내보내기 품질:",
    "subTitle-fileNum": "문서 수:",
    "anti-lost": "손실 방지",
    "tamper-proof": "변조 방지",
    "default": "기본",
    "nonwatermark": "워터마크 없음",
    "pageIllustrate": "예시:&quot;1,3,5-10&quot;",
    "export": "내보내기 ",
    "confirm": "확인 ",
    "cancel": "취소 ",
    "currentPage": "현재 페이지",
    "selectPage": "페이지 선택하기",
    "selectShape": "선택한 셰이프",
    "allPage": "모든 페이지",
    "allShape": "현재 페이지의 모든 형태",
    "PDFImg": "이미지 기반 PDF",
    "PDFVector": "일반 PDF",
    "singlePDF": "하나의 PDF로 내보내기",
    "multiplePDF": "분리된 PDF로 내보내기",
    "resolution-normal": "일반",
    "resolution-origin": "고화질"
  },
  "id": {
    "subTitle-range": "Rentang ekspor:",
    "subTitle-type": "Opsi ekspor:",
    "subTitle-quality": "Kualitas ekspor:",
    "subTitle-watermark": "Pengaturan watermark:",
    "subTitle-fileNum": "Jumlah dokumen:",
    "anti-lost": "Loss-proof",
    "tamper-proof": "Tamper-resistant",
    "allShape": "Semua bentuk pada halaman saat ini"
  }
}
</i18n>
